<template>
    <main class="p-8 overflow-y-auto text-black dark:bg-black dark:text-white flex-1">
        <slot></slot>
    </main>
</template>